import {
	doFormValidation,
	doPhoneFieldValidation,
	onFieldInput

} from '../lib/forms';

let form;

const init = () => {
	form = document.querySelector('.js-main-profile-form');
	if (!form) return;

	let fieldsRequired = [
		'LAST_NAME',
		'NAME',
		'EMAIL'
	];

	fieldsRequired.forEach((fieldCode) => {
		let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
		if (!fieldElement) return;

		fieldElement.addEventListener('input', onFieldInput);
	});

	// submit
	form.addEventListener('submit', (e) => {
		let hasErrors = false;

		let fieldsChecked = doFormValidation(form, fieldsRequired, e);
		let phoneChecked = doPhoneFieldValidation(form, 'UF_PHONE_NUMBER', e);

		if (!fieldsChecked || !phoneChecked) {
			hasErrors = true;
			e.preventDefault();
		}

		return hasErrors === false;
	});
};

export default {
	init
};